/**
 * Date now in string iso format
 */ 
export const DateNowIsoString = () => {
    return new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
}